import $ from "jquery";

import * as analytics from "analytics";

export const install = () => {
  const link = $('link[rel="chrome-webstore-item"]');
  if (link.length > 0) {
    analytics.trackEvent("chromeExtension-startInstall");
    window.chrome.webstore.install(
      link.attr("href"),
      () => {
        analytics.trackEvent("chromeExtension-finishInstall", () => {
          window.location.href = "/links";
        });
      },
      () => {
        // Install failed
      }
    );
  }
};
